require("packs/raty")
import starOn from "images/star-on.svg"
import starOff from "images/star-off.svg"
import starHalf from "images/star-half.svg"

$(function(){
  window.display_raty_stars('.average-review');
  window.display_raty_stars('.index-individual-review');
  $('#rating-form').raty({
    starOn: starOn,
    starOff: starOff,
    starHalf: starHalf,
    number: 10,
    scoreName: 'review[rating]',
    click: function(score) {
      var form = document.querySelector('form.new_video_review');
      form.elements[0].value = score;
      Rails.fire(form, 'submit');
    }
  })
});

window.display_raty_stars=function(selector){
  $(selector).raty({
    readOnly: true,
    starOn: starOn,
    starOff: starOff,
    starHalf: starHalf,
    number: 10,
    score: function() {
      return $(this).attr('data-score');
    }
  });
}

$(document).on('click', '.paginate_ajax th a, .paginate_ajax .pagination a', function(){
  $.getScript(this.href);
  return false;
})

var maxchars = 200;
$(document).on('keyup', '#video_review_comment', function(){
  var tlength = $(this).val().length;
  $(this).val($(this).val().substring(0, maxchars));
  var tlength = $(this).val().length;
  var remain = maxchars - parseInt(tlength);
  var txt = $('#remain').attr('for')
  $('#remain').text(remain + ' ' + txt);
})
